// extracted by mini-css-extract-plugin
export default {"col":"styles_col__OO9y2","formContainer":"styles_formContainer__15Mrn","form":"styles_form__SE9NE"};